<template>
  <share
    v-if="renderShare"
    :url="blockAction ? blockAction.url : ''"
    ref="blockActionShare"
  />
</template>

<script>
import { mapActions } from "vuex"

import HandleNextPage from "@/lib/mixins/handle-next-page"
import BlockAction from "@/lib/mixins/block-action"

import EventBus, { EVENTS } from "@/lib/event-bus"
import { isObject } from "@/lib/utils"
import { BLOCK_ACTIONS } from "@/lib/stream-utils"

import Share from "@/components/block-actions/Share"

export default {
  mixins: [BlockAction, HandleNextPage],

  components: {
    Share
  },

  data() {
    return {
      renderShare: false,
      blockAction: null
    }
  },

  mounted() {
    if (!this.isPreview && this.isActionQueryPresent) {
      this.fetchAndTriggerBlockAction(this.$route.query["block-action"])
    }

    EventBus.$on(EVENTS.TRIGGER_BLOCK_ACTION, blockActionData => {
      if (isObject(blockActionData)) {
        this.blockAction = blockActionData
        this.triggerBlockAction()
      } else {
        this.fetchAndTriggerBlockAction(blockActionData)
      }
    })
  },

  methods: {
    isObject,

    ...mapActions("auth", ["fetchBlockAction"]),
    ...mapActions("pages", ["fetchPagePath"]),

    async fetchAndTriggerBlockAction(blockActionId) {
      const response = await this.fetchBlockAction(blockActionId)

      this.blockAction = response.block_action
      this.triggerBlockAction()
    },

    triggerBlockAction() {
      if (this.isTriggerable) {
        this.trigger()

        return
      } else if (this.blockAction.action === BLOCK_ACTIONS.OPEN_PAGE) {
        if (this.blockAction.link) {
          return this.$router.push(this.blockAction.link)
        } else {
          this.fetchPagePath(this.blockAction.page_id).then(path => {
            this.$router.push(path)
          })
        }
      } else if (this.blockAction.action === BLOCK_ACTIONS.OPEN_URL) {
        window.open(this.blockAction.url, "_blank")
      } else if (this.isLink) {
        window.location.href = this.blockAction.link
      } else if (this.isShareLink) {
        this.renderShare = true
        this.$nextTick(() => {
          this.$refs.blockActionShare.share()
        })
      } else if (this.blockAction.action === BLOCK_ACTIONS.OPEN_NEXT) {
        this.handleNextPage()
      }

      this.$router.replace({ query: null })
    }
  }
}
</script>
